import {
  StandardProductReducerActions,
  StandardProductReducerState,
  useStandardProductReducer,
} from "app/hooks/shared/standard-product/useStandardProductReducer";
import { createContext, useContext, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { PANEL_CATEGORY_CODE } from "../../shared/utils/standard-product";

interface StandardProductProviderValue {
  store: StandardProductReducerState;
  actions: StandardProductReducerActions;
  showStandardProducts: boolean;
  showSampleComponent: boolean;
  isKleurStaalCategory: boolean;
}

export const StandardProductContext = createContext(
  {} as StandardProductProviderValue,
);
export const useStandardProductContext = () =>
  useContext(StandardProductContext);

const StandardProductProvider = ({ children }: any) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { store, actions } = useStandardProductReducer();

  const showStandardProducts = useMemo(
    () => !!searchParams.get("standard-product"),
    [searchParams],
  );
  const showSampleComponent = useMemo(
    () =>
      store !== undefined &&
      store.selectedStandardProduct !== undefined &&
      store.selectedStandardProduct?.productType.code === PANEL_CATEGORY_CODE,
    [store],
  );

  const isKleurStaalCategory =
    !!store?.selectedStandardProductCategory?.code.includes("kleurstaal");

  const value = useMemo(() => {
    return {
      store,
      actions,
      showStandardProducts,
      showSampleComponent,
      isKleurStaalCategory,
    };
  }, [
    actions,
    showSampleComponent,
    showStandardProducts,
    store,
    isKleurStaalCategory,
  ]);

  return (
    <StandardProductContext.Provider value={value}>
      {children}
    </StandardProductContext.Provider>
  );
};
export default StandardProductProvider;
